export default __webpack_public_path__ + "static/media/GuyAnimation1.efc91dda.svg";